const LOCALISE_FULFILMENT = 'LOCALISE_FULFILMENT'

export { LOCALISE_FULFILMENT } // eslint-disable-line
